export const styleOptions = [
    {
        label: '鼓励激励型',
        value: '鼓励激励型'
    },
    {
        label: '细节具象型',
        value: '细节具象型'
    },
    {
        label: '正式客观型',
        value: '正式客观型'
    },
    {
        label: '亲切温暖型',
        value: '亲切温暖型'
    },
    {
        label: '犀利中肯型',
        value: '犀利中肯型'
    }
    // {
    //     label: '自定义',
    //     value: '自定义'
    // }
];
export const errText = {
    title: '请输入评阅主题',
    criteria: '请输入评阅标准',
    style: '请输入内容'
};
export const placeHolder = {
    title: '请输入评阅主题',
    criteria: `请定义评阅指标，若有明确的指标分值和评阅标准也可说明，如：
立意明确：满分2分，完全符合打2分，基本符合打1分，不符合打0分
逻辑通顺：满分3分，逻辑非常好打3分，逻辑一般打1-2分，逻辑不通打0分`,
    style: '请输入内容',
    requirements: '请输入评语要求'
};
export const statusMap = {
    0: '未完成',
    1: '已完成',
    2: '进行中',
    3: '失败'
};
